import { Colors } from '@sigma-frontend-libs/commons'

import { components, permissionPresets, services, states } from '@/utils'

import button from '@/components/button'
import preloader from '@/components/preloader'
import accountForm from '@/components/services/account/form'
import documentTemplatesGenerateButton from '@/components/services/documentTemplates/generate/button'
import sticker from '@/components/sticker'

function renderPreLoader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderUsername(h) {
  let iconSVG = 'user'
  let color = Colors.grey
  if (this.verified) {
    iconSVG = 'user-verified'
    color = Colors.info
  }

  return h(
    sticker,
    {
      props: {
        value: this.username,
        label: this.name,
        iconSVG,
        color,
        maxWidth: 300
      }
    }
  )
}
function renderDocumentTemplatesGenerateButton(h) {
  return h(
    documentTemplatesGenerateButton,
    {
      props: {
        OwnerId: this.account.id
      }
    }
  )
}
function renderHeader(h) {
  if (this.restData[services.users].get.state === 'ready') {
    return h(
      'div',
      {
        class: 'grid grid-gap--8',
        style: {
          gridTemplateColumns: 'repeat(2, auto)',
          justifyContent: 'space-between'
        }
      },
      [
        renderUsername.call(this, h),
        renderDocumentTemplatesGenerateButton.call(this, h)
      ]
    )
  }
}

function renderForm(h) {
  return h(
    accountForm,
    {
      props: {
        value: this.restData[services.users].get.data,
        errors: this.restData[services.users].update.errors,
        saveSuccessKey: this.updateSuccessKey
      },
      on: {
        input: event => {
          this.restData[services.users].get.data = event
        },
        submit: () => {
          if (!this.updateDisabled) {
            this.update()
          }
        },
        validation: event => {
          this.formValidation = event
        }
      }
    }
  )
}
function renderCardContent(h) {
  if (this.restData[services.users].get.state === states.loading) {
    return renderPreLoader.call(this, h)
  } else if (this.restData[services.users].get.state === states.ready) {
    return renderForm.call(this, h)
  }

  return h(components.empty)
}
function renderBody(h) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      }
    },
    [ renderCardContent.call(this, h) ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.update'),
            color: Colors.primary,
            loading: this.restData[services.users].update.state === states.loading,
            disabled: this.updateDisabled
          },
          on: {
            click: () => {
              if (!this.updateDisabled) {
                this.update()
              }
            }
          }
        }
      )
    ]
  )
}

function renderContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.checkPermissions(`advanced.${services.users}.get`, permissionPresets.meUp)) {
    let gridTemplateColumns
    if (this.viewport.breakpoint.lgUp) {
      gridTemplateColumns = '800px 1fr'
    }

    return h(
      'div',
      {
        class: 'grid faifs',
        style: { 'grid-template-columns': gridTemplateColumns }
      },
      [ renderContent.call(this, h) ]
    )
  }
}
